import O1HD from "../../engines/gameEngine";
import utilsView from "../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../engines/modules/uiModule";
import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { BUNDLE_SMALL_NAME } from "../../modes/normalMode/BundleResourceConfig";
import chooseConcubineGame from "./chooseConcubineGame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class chooseConcubineConcubine extends cc.Component {

    @property({type:sp.Skeleton,tooltip:"妃子图片",displayName:"妃子图片"})
    people01:sp.Skeleton = null;

    @property({type:sp.Skeleton,tooltip:"盖头节点",displayName:"盖头节点"})
    lidNode:sp.Skeleton = null;

    @property({type:cc.Node,tooltip:"脚节点",displayName:"脚节点"})
    footNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"脚臭节点",displayName:"脚臭节点"})
    footOdor:cc.Node = null;

    @property({type:cc.Node,tooltip:"羽毛节点",displayName:"羽毛节点"})
    featherNode:cc.Node = null;

    @property({type:sp.Skeleton,tooltip:"狗动画节点",displayName:"狗动画节点"})
    dogAni:sp.Skeleton = null;

    @property({type:cc.Node,tooltip:"狗倒地节点"})
    dogDeathSp:cc.Node = null;

    @property({type:cc.Node,tooltip:"勾节点"})
    trueNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"鞋子节点"})
    shoseNode:cc.Node = null;

    @property({type:sp.Skeleton,tooltip:"腿毛动画"})
    people02:sp.Skeleton = null;

    /**妃子类型，0是漂亮妃子 1是丑妃子 2是声音难听的妃子 3是有腿毛的妃子 4是有体臭的妃子 */
    private concubineType:number = 0;
    
    private isAni:boolean = false;

    private checkAudioCount:number = 0;

    private chooseGame:chooseConcubineGame = null;

    checkState:boolean = false;

    @property({type:cc.Node,tooltip:"阴影节点"})
    shadowNode:cc.Node = null;

    /**
     * 设置妃子类型
     * @param type 类型
     */
    setConcubineType(type:number,game:chooseConcubineGame){
        this.concubineType = type;
        this.chooseGame = game;
    }

    getConcubineType(){
        return this.concubineType;
    }

    onLoad(){
        this.initConcubine();
        this.hideShadow();
        console.log("concubine onload");
    }

    initConcubine(){
        // this.concubineSp.spriteFrame = this.normalSp;
        this.people01.node.active = true;
        this.people02.node.active = false;
        this.footNode.active = false;
        this.footOdor.active = false;
        this.dogAni.node.active = false;
        this.dogDeathSp.active = false;
        this.featherNode.active = false;
        this.trueNode.active = false;
        this.shoseNode.active = false;
        this.isAni = false;
        this.people01.setAnimation(0,"Idle",true);
        this.lidNode.setAnimation(0,"Idle",true);
    }

    /**
     * 羽毛动画
     */
    featherAni(){
        return new Promise<void>(resolve=>{
            this.featherNode.active = true;
            let spine = this.featherNode.getComponent(sp.Skeleton);
            spine.setAnimation(0,"animation",false);
            spine.setCompleteListener(()=>{
                this.featherNode.active = false;
                resolve();
                spine.setCompleteListener(()=>{});
            });
        });
    }

    /**
     * 判断是否是声音难听的妃子
     */
    async checkAudioFail(){
        if(this.isAni){
            // 等待当前动作结束
            O1HD.getModules().uiControlModule.showMessageBox("等待当前动作结束");
            return;
        }
        this.people01.setAnimation(0,"02",true);
        this.lidNode.setAnimation(0,"02",true);
        this.isAni = true;
        this.checkAudioCount++;
        let soundPath : string = `laugh${this.node.getSiblingIndex()}`;
        if(this.checkAudioCount >= 3){
            // 判断是否是声音难听的妃子，如果是则发出男人的声音 如果不是则发出娇羞的声音
            if(this.concubineType == 2){
                // 发出男人的声音
                this.chooseGame.peopleRemoveEvent();
                soundPath = "manlaugh";
            }
        }
        this.scheduleOnce(()=>{
            O1HD.getManagers().soundMgr.playSound(soundPath,null,BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
        },0.5);
        await this.featherAni();
        this.people01.setAnimation(0,"Idle",true);
        this.lidNode.setAnimation(0,"Idle",true);
        if(this.checkAudioCount >= 3){
            if(this.concubineType == 2){
                this.chooseGame.changePauseTime(true);
                this.chooseGame.peopleRemoveEvent();
                this.showTrues().then(()=>{
                    this.chooseGame.chooseComplete();
                });
            }
        }
        this.isAni = false;
    }

    /**
     * 判断是否是皮肤不好的妃子 
    */
    checkskinFail(){
        // 打开放大镜
    }

    moveGlass(e:cc.Event.EventTouch){
        let detal:cc.Vec2 = e.getDelta();

        let minX:number = -35;
        let maxX:number = 50;

        let minY:number = -240;
        let maxY:number = 200;

        let node:cc.Node = e.target;

        if(node.x + detal.x < minX){
            detal.x = minX - node.x;
        }else if(node.x + detal.x > maxX){
            detal.x = maxX - node.x;
        }

        if(node.y + detal.y < minY){
            detal.y = minY - node.y;
        }else if(node.y + detal.y > maxY){
            detal.y = maxY - node.y;
        }
        node.x += detal.x;
        node.y += detal.y;
    }

    /**
     * 判断是否是有体味的妃子
     */
    checkOdourFail(){
        if(this.isAni){
            // 等待当前动作结束
            O1HD.getModules().uiControlModule.showMessageBox("等待当前动作结束");
            return;
        }
        // 放狗
        this.isAni = true;
        this.dogAni.node.opacity = 0;
        this.dogAni.node.active = true;
        cc.tween(this.dogAni.node).to(0.5,{opacity:255}).call(()=>{
            O1HD.getManagers().soundMgr.playSound("dogSmell",null,BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
            this.dogAni.setAnimation(0,"animation",false);
        }).delay(2).call(()=>{
            if(this.concubineType == 4){
                if(this.shoseNode.active){
                    cc.tween(this.dogAni.node).to(0.5,{opacity:0}).call(()=>{
                        this.isAni = false;
                    }).start();    
                }else{
                    this.chooseGame.changePauseTime(true);
                    O1HD.getManagers().soundMgr.playSound("dogDeath",null,BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
                    this.dogAni.node.active = false;
                    this.dogDeathSp.active = true;
                    this.footOdor.active = true;
                    this.footOdor.opacity = 0;
                    this.chooseGame.peopleRemoveEvent();
                    cc.tween(this.footOdor).to(1,{opacity:255}).call(()=>{
                        this.showTrues().then(()=>{
                            this.chooseGame.chooseComplete();
                            let data = {
                                id: "45"
                                , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                                , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                            }
                            utilsView.openEventLayer(
                                null
                                , data
                                , UI_Z_INDEX.DIALOG
                            );
                        });
                    }).start();
                }
            }else{
                cc.tween(this.dogAni.node).to(0.5,{opacity:0}).call(()=>{
                    this.isAni = false;
                }).start();
            }
        }).start();
    }

    /**
     * 改变状态
     * @param state 0
     */
    changeState(state:number){
        switch(state){
            case 0:{
                
                break;
            }
            case 1:{
                this.people01.node.active = false;
                this.people02.node.active = true;
                if(this.concubineType == 3){
                    this.checkState = true;
                    this.people02.setSkin("TuiMao");
                }else{
                    this.people02.setSkin("Normal");
                }
                break;
            }
            case 2:{
                this.footNode.active = true;
                this.shoseNode.active = true;
                this.shoseNode.on('touchend',this.onTouchEndFoot,this);
                break;
            }
        }
    }

    onTouchEndFoot(e:cc.Event.EventTouch){
        this.shoseNode.off("touchend",this.onTouchEndFoot,this);
        this.shoseNode.active = false;
    }

    showTrues(){
        O1HD.getManagers().soundMgr.playSound("inLevel");
        this.trueNode.active = true;
        return new Promise<void>(resolve=>{
            this.scheduleOnce(resolve,2);
        });
    }

    hideTrues(){
        this.trueNode.active = false;
    }

    showShadow(){
        this.shadowNode.active = true;
    }

    hideShadow(){
        this.shadowNode.active = false;
    }

}
